// import React, { useEffect, useState } from 'react';

// import './App.css';
// import HeroSection from './pages/Hero';
// import Header from './pages/Header';
// import WhyChooseUs from './pages/WhyChooseUs';
// import { Features } from './Componants/Features';
// import TrustSection from './Componants/TrustSection';
// import HeroVideoSection from './Componants/HeroVideoSection';
// import TrustBadgesSection from './Componants/TrustBadgesSection';
// import PreFooterHero from './Componants/PreFooterHero';
// import Footer from './Componants/Footer';



// function App() {

//    const [userLocation, setUserLocation] = useState<GeolocationCoordinates | null>(null);
//   const [locationError, setLocationError] = useState<string | null>(null);

//   useEffect(() => {
//     // Check if geolocation is supported by the browser
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           // Success callback
//           setUserLocation(position.coords);
//           console.log("Latitude:", position.coords.latitude);
//           console.log("Longitude:", position.coords.longitude);
//         },
//         (error) => {
//           // Error callback
//           switch (error.code) {
//             case error.PERMISSION_DENIED:
//               setLocationError("User denied the request for Geolocation.");
//               console.error("User denied the request for Geolocation.");
//               break;
//             case error.POSITION_UNAVAILABLE:
//               setLocationError("Location information is unavailable.");
//               console.error("Location information is unavailable.");
//               break;
//             case error.TIMEOUT:
//               setLocationError("The request to get user location timed out.");
//               console.error("The request to get user location timed out.");
//               break;
//             default:
//               setLocationError("An unknown error occurred.");
//               console.error("An unknown error occurred.");
//               break;
//           }
//         },
//         {
//           // Options for geolocation
//           enableHighAccuracy: true, // Request a more precise location
//           timeout: 5000,           // Maximum time to wait for a location (5 seconds)
//           maximumAge: 0            // Don't use a cached position
//         }
//       );
//     } else {
//       setLocationError("Geolocation is not supported by this browser.");
//       console.error("Geolocation is not supported by this browser.");
//     }
//   }, []); // Empty dependency array means this effect runs once after the initial render


//   return (
//    <>
//    <Header />
//    <HeroSection />
//    <WhyChooseUs />
//    <Features />
//    <TrustSection />
//    <HeroVideoSection />
//    <TrustBadgesSection />
//    <PreFooterHero />
//    <Footer />


//    </>
//   );
// }

// export default App;

import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'; // Import routing components

import './App.css';
import HeroSection from './pages/Hero';
import Header from './pages/Header';
import WhyChooseUs from './pages/WhyChooseUs';
import { Features } from './Componants/Features';
import TrustSection from './Componants/TrustSection';
import HeroVideoSection from './Componants/HeroVideoSection';
import TrustBadgesSection from './Componants/TrustBadgesSection';
import PreFooterHero from './Componants/PreFooterHero';
import Footer from './Componants/Footer';
import AndroidPage from './pages/Header_Pages/Android';
import IphoneApp from './pages/Header_Pages/IphoneApp';
import ScamAlertPage from './pages/Header_Pages/ScamAlert';
import SolutionPage from './pages/Header_Pages/SolutionPage';
import COCTrail from './pages/COCTrail';
import { FaCommentAlt } from 'react-icons/fa';
import SearchResultPage from './Componants/SearchResultPage';



// import IphoneApp from './IphoneApp'; // Import your iPhone App component
// import AndroidPage from './Android'; // Import your Android Page component


function App() {

  // This component will automatically scroll to the top of the page on route change.
const ScrollToTop = () => {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);
    return null;
};

  const [userLocation, setUserLocation] = useState<GeolocationCoordinates | null>(null);
  const [locationError, setLocationError] = useState<string | null>(null);

  useEffect(() => {
    // Check if geolocation is supported by the browser
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Success callback
          setUserLocation(position.coords);
          console.log("Latitude:", position.coords.latitude);
          console.log("Longitude:", position.coords.longitude);
        },
        (error) => {
          // Error callback
          switch (error.code) {
            case error.PERMISSION_DENIED:
              setLocationError("User denied the request for Geolocation.");
              console.error("User denied the request for Geolocation.");
              break;
            case error.POSITION_UNAVAILABLE:
              setLocationError("Location information is unavailable.");
              console.error("Location information is unavailable.");
              break;
            case error.TIMEOUT:
              setLocationError("The request to get user location timed out.");
              console.error("The request to get user location timed out.");
              break;
            default:
              setLocationError("An unknown error occurred.");
              console.error("An unknown error occurred.");
              break;
          }
        },
        {
          // Options for geolocation
          enableHighAccuracy: true, // Request a more precise location
          timeout: 5000,           // Maximum time to wait for a location (5 seconds)
          maximumAge: 0            // Don't use a cached position
        }
      );
    } else {
      setLocationError("Geolocation is not supported by this browser.");
      console.error("Geolocation is not supported by this browser.");
    }
  }, []); // Empty dependency array means this effect runs once after the initial render


  return (
    <>
    
      <Header /> {/* Header can be outside Routes if it's common to all pages */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={
          <>
            <HeroSection />
            <COCTrail />
            <WhyChooseUs />
            <Features />
             <HeroVideoSection />
            <TrustSection />

            <TrustBadgesSection />
           
          </>
        } />
        <Route path="/Android" element={<AndroidPage />} />
        <Route path="/iphone" element={<IphoneApp />} />
        <Route path="/coc-alert" element={<ScamAlertPage />} />
        <Route path="/solutions" element={<SolutionPage />} />
       <Route path="/search-result" element={<SearchResultPage />} />

        
      </Routes>
       <PreFooterHero />
      <Footer /> {/* Footer can also be outside Routes */}

     
      
    </>
  );
}

export default App;